import { AlertIcon, Modal, Note, SecondaryButton, Spinner } from '@movingimage-evp/mi-ui-component-library';
import { t } from 'i18next';

import styles from './ingest-active-modal.module.css';

type Props = {
  isOpen: boolean;
  isLoading: boolean;
  onClose: () => void;
  onTryAgain: () => void;
};

export function IngestActiveModal({ isOpen, isLoading, onClose, onTryAgain }: Props) {
  return (
    <Modal
      data-testid="ingest-active-modal"
      className={styles.wrapper}
      title={
        <>
          <AlertIcon className={styles.alertIcon} /> {t('manager.webcastSetup.language.ingestActiveModal.title')}
        </>
      }
      isOpen={isOpen}
      onClose={onClose}
      contentProps={{ className: styles.modal }}
      footer={
        <SecondaryButton
          data-testid="ingest-active-modal-try-again"
          type="button"
          small
          disabled={isLoading}
          onClick={onTryAgain}
        >
          <span className={styles.tryAgainContent}>
            {t('manager.webcastSetup.language.ingestActiveModal.tryAgain')}
            {isLoading && <Spinner />}
          </span>
        </SecondaryButton>
      }
    >
      <p className={styles.description}>{t('manager.webcastSetup.language.ingestActiveModal.description')}</p>

      <Note className={styles.warning} testId="ingest-active-modal-warning" variant="warning">
        {t('manager.webcastSetup.language.ingestActiveModal.warning')}
      </Note>
    </Modal>
  );
}
